import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const sepia: ThemeDefinition = {
  label: "Sepia",
  className: "theme-sepia",
  bg: "#1c1610",
  text: "#c8b898",
  textMuted: "rgba(200,184,152,0.55)",
  accent: "#a89040",
  glassRgb: "28,22,16",
  border: "rgba(255,255,255,0.08)",
  borderHighlight: "rgba(255,255,255,0.18)",
  separator: "rgba(200,184,152,0.18)",
  selection: "#a89040",
  selectionText: "#1c1610",
  gridColor: "#c8b898",
  noiseOpacity: "0.05",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.1), 0 10px 0px rgba(0,0,0,0.55)",
  gpuClear: hexToSrgb("#1c1610"),
  gpuGridLine: hexToLinear("#c8b898"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#a89040"),
  gpuAxisZ: hexToLinear("#c8b898"),
  axisXColor: "#a89040",
  axisZColor: "#c8b898",
  font: '"Libre Baskerville", serif',
  fontImport: 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&display=swap',
};
